// extracted by mini-css-extract-plugin
export default {"accountSettings":"AccountSettings_accountSettings__yeKcw"};